<div class="modal-overlay">
  <div class="add-stock-modal">
    <div class="modal-header">
      <h2>{{ dialogTitle }}</h2>
      <button type="button" class="close-btn" (click)="onCancel()">✕</button>
    </div>

    <div class="modal-content">
      <form *ngIf="stockForm" [formGroup]="stockForm">

        <div class="card-section">
          <div class="section-header">
            <h3>{{ 'addStock.storeSelection' | translate }}</h3>
          </div>
          <div class="form-field form-field-full">
            <label for="storeId">{{ 'addStock.store' | translate }} *</label>
            <select id="storeId" [formControl]="stockForm.controls.storeId" class="form-control"
              [class.error]="stockForm.controls.storeId.invalid && stockForm.controls.storeId.touched">
              <option [value]="null" disabled selected hidden>{{ 'addStock.selectStore' | translate }}</option>
              <option *ngFor="let store of stores" [value]="store.id">{{ store.name }}</option>
            </select>
            <div *ngIf="stockForm.controls.storeId.invalid && stockForm.controls.storeId.touched" class="error-message">
              {{ 'addStock.validation_errors.store_required' | translate }}
            </div>
          </div>
        </div>

        <div class="card-section">
          <div class="form-field form-field-full">
            <div class="section-header">
              <h3>{{ 'addStock.product_type' | translate }}</h3>
            </div>
            <label for="productCategoryId">{{ 'addStock.category' | translate }} <span
                class="required-mark">*</span></label>
            <select id="productCategoryId" [formControl]="stockForm.controls.productCategoryId" class="form-control"
              [class.error]="stockForm.controls.productCategoryId.invalid && stockForm.controls.productCategoryId.touched">
              <option [value]="null" disabled selected hidden>{{ 'addStock.selectCategory' | translate }}</option>
              <option *ngFor="let category of categories" [value]="category.productCategoryId">
                {{category.productCategoryCode}}</option>
            </select>

            <div *ngIf="stockForm.controls.productCategoryId.invalid && stockForm.controls.productCategoryId.touched"
              class="error-message">
              <ng-container *ngIf="stockForm.getFieldErrorMessage(stockForm.controls.productCategoryId) as error">
                {{ error.key | translate:error.params }}
              </ng-container>
            </div>
          </div>
        </div>

        <div class="card-section">
          <div class="section-header">
            <h3>{{ 'addStock.searcheBrand' | translate }}</h3>
          </div>
          <div class="form-row">
            <div class="form-field form-field-full">
              <label for="brandSearch">{{ 'addStock.brand' | translate }}</label>
              <app-tire-brand-dropdown [brandFilter]="stockForm.value.brandSearch ?? ''"
                (brandFilterEmitter)="updateSearcherBrand($event)"></app-tire-brand-dropdown>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field form-field-full">
              <label for="productSearch">{{ 'addStock.searchProduct' | translate }} </label>
              <div class="search-container">
                <input type="text" id="productSearch" [formControl]="stockForm.controls.productSearch"
                  class="form-control" placeholder="{{ 'addStock.searchPlaceholder' | translate }}">
                <button type="button" class="clear-btn" *ngIf="stockForm.controls.productSearch.value"
                  (click)="clearProductSelection()">✕</button>
              </div>
              <span class="search-hint">{{ 'addStock.typeToSearch' | translate }}</span>
              <div class="options-dropdown" *ngIf="showProductDropdown">
                <div class="loading" *ngIf="isLoadingProducts">{{ 'addStock.loading' | translate }}...</div>
                <ng-container *ngIf="!isLoadingProducts">
                  <button class="product-item" *ngFor="let product of filteredProducts"
                    (click)="selectProductFromDropdown(product)">
                    <span class="product-code">{{ product.productCode }} </span> -
                    <span class="product-name"> {{ product.productName }}</span>
                  </button>
                  <div class="no-results" *ngIf="!isLoadingProducts && filteredProducts.length === 0">
                    {{ 'addStock.noProductsFound' | translate }}
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>


        <div class="card-section">
          <div class="section-header">
            <h3>{{'addStock.lot_info' | translate}}</h3>
          </div>
          <div class="form-row">
            <div class="form-field form-field-full">
              <label for="quantity">{{ 'addStock.quantity' | translate }} <span class="required-mark">*</span></label>
              <div class="number-input-container">
                <button type="button" class="number-btn" (click)="decrementQuantity()">-</button>
                <input type="number" id="quantity" [formControl]="stockForm.controls.quantity" class="number-input"
                  min="1">
                <button type="button" class="number-btn increment" (click)="incrementQuantity()">+</button>
              </div>
              <div *ngIf="stockForm.controls.quantity.invalid && stockForm.controls.quantity.touched"
                class="error-message">
                <ng-container *ngIf="stockForm.getFieldErrorMessage(stockForm.controls.quantity) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field form-field-full">
              <label for="quantity">{{'pages.stock.add_stock.locations' | translate}}</label>
              <app-location-stock-input id="locations" [tagsArray]="stockForm.controls.location"
                [placeholder]="('pages.stock.add_stock.locations' | translate) + '...'"
                [error]="stockForm.controls.location.invalid"
                [errorMessage]="'pages.stock.lots.validation.locations' | translate"></app-location-stock-input>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field form-field-half">
              <label for="dot">{{ 'addStock.dotDate' | translate }} <span class="required-mark">*</span></label>
              <input type="text" id="dot" [formControl]="stockForm.controls.dot" class="form-control"
                [class.error]="stockForm.controls.dot.invalid && stockForm.controls.dot.touched" maxlength="4"
                placeholder="2324">
              <div *ngIf="stockForm.controls.dot.invalid && stockForm.controls.dot.touched" class="error-message">
                <ng-container *ngIf="stockForm.getFieldErrorMessage(stockForm.controls.dot) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>
              </div>
            </div>
            <div class="form-field form-field-half">
              <label for="entryDate">{{ 'addStock.entryDate' | translate }} <span class="required-mark">*</span></label>
              <app-date-input [formControl]="stockForm.controls.entryDate" [showLabel]="false"
                [placeholder]="'common.selectDate'" [required]="true" [clearable]="true">
              </app-date-input>
              <div *ngIf="stockForm.controls.entryDate.invalid && stockForm.controls.entryDate.touched"
                class="error-message">
                <ng-container *ngIf="stockForm.getFieldErrorMessage(stockForm.controls.entryDate) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field form-field-half">
              <label for="costPrice">{{ 'addStock.costPrice' | translate }} <span class="required-mark">*</span></label>
              <input type="number" id="costPrice" [formControl]="stockForm.controls.price" class="form-control"
                placeholder="{{ 'addStock.costPricePlaceholder' | translate }}" step="0.01" min="0"
                [class.error]="stockForm.controls.price.invalid  && stockForm.controls.price.touched">
              <div *ngIf="stockForm.controls.price.invalid && stockForm.controls.price.touched" class="error-message">
                <ng-container *ngIf="stockForm.getFieldErrorMessage(stockForm.controls.price) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>

              </div>
            </div>

          </div>
        </div>

        <!-- PRODUCT DATA -->

        <div class="card-section" *ngIf="stockForm.controls.newTireProduct as newProduct"
          [formGroup]="stockForm.controls.newTireProduct">

          <div class="section-header">
            <h3>{{'addStock.tire_data' | translate}}</h3>
            <button class="btn-secondary" (click)="clearProductSelection()"
              *ngIf="stockForm.controls.productId.value">{{'addStock.diselect_product' | translate}}</button>
          </div>
          <div class="form-row">
            <div class="form-field form-field-half">
              <label for="code">{{ 'addStock.productCode' | translate }} <span class="required-mark">*</span></label>
              <input type="text" id="code" [formControl]="newProduct.controls.code" class="form-control"
                placeholder="{{ 'addStock.productCodePlaceholder' | translate }}"
                [class.error]="newProduct.controls.code.invalid && newProduct.controls.code.touched"
                [class.disabled]="newProduct.controls.code.disabled">
              <div *ngIf="newProduct.controls.code.invalid && newProduct.controls.code.touched" class="error-message">
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.code) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>

              </div>
            </div>
            <div class="form-field form-field-half">
              <label for="name">{{ 'addStock.productName' | translate }} <span class="required-mark">*</span></label>
              <input type="text" id="name" [formControl]="newProduct.controls.name" class="form-control"
                placeholder="{{ 'addStock.productNamePlaceholder' | translate }}"
                [class.error]="newProduct.controls.name.invalid && newProduct.controls.name.touched"
                [class.disabled]="newProduct.controls.name.disabled">
              <div *ngIf="newProduct.controls.name.invalid && newProduct.controls.name.touched" class="error-message">
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.name) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>
              </div>
            </div>
          </div>

          <div class="form-row">
            <!-- <div class="form-field form-field-half">

              <label for="categoryId">{{ 'addStock.category' | translate }} <span class="required-mark">*</span></label>
              <select id="categoryId" [formControl]="newProduct.controls.productCategoryId" class="form-control"
                [class.error]="newProduct.controls.productCategoryId.invalid && newProduct.controls.productCategoryId.touched"
                [class.disabled]="newProduct.controls.productCategoryId.disabled">
                <option [value]="null" disabled selected hidden>{{ 'addStock.selectCategory' | translate }}</option>
                <option *ngFor="let category of categories" [value]="category.id">{{ category.name }}</option>
              </select>

              <div *ngIf="newProduct.controls.productCategoryId.invalid && newProduct.controls.productCategoryId.touched"
                class="error-message">
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.productCategoryId) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>

              </div>
            </div> -->

            <div class="form-field form-field-half">
              <label for="subcategoryId">{{ 'addStock.subCategory' | translate }} <span
                  class="required-mark">*</span></label>
              <select id="subcategoryId" [formControl]="newProduct.controls.subCategoryGuid" class="form-control"
                [class.error]="newProduct.controls.subCategoryGuid.invalid && newProduct.controls.subCategoryGuid.touched"
                [class.disabled]="newProduct.controls.subCategoryGuid.disabled">
                <option [value]="null" disabled selected hidden>{{ 'addStock.subCategory' | translate }}</option>
                <option *ngFor="let subcategory of subcategories" [value]="subcategory.subCategoryId">{{
                  subcategory.subCategoryName }}
                </option>
              </select>

              <div *ngIf="newProduct.controls.subCategoryGuid.invalid && newProduct.controls.subCategoryGuid.touched"
                class="error-message">
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.subCategoryGuid) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>

              </div>
            </div>

          </div>

          <div class="form-row">
            <div class="form-field form-field-half">
              <label for="ean">{{ 'addStock.ean' | translate }} <span class="required-mark">*</span></label>
              <input type="text" id="ean" [formControl]="newProduct.controls.identifier" class="form-control"
                placeholder="{{ 'addStock.eanPlaceholder' | translate }}"
                [class.error]="newProduct.controls.identifier.invalid && newProduct.controls.identifier.touched"
                [class.disabled]="newProduct.controls.identifier.disabled">
              <div *ngIf="newProduct.controls.identifier.invalid && newProduct.controls.identifier.touched"
                class="error-message">
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.identifier) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>

              </div>
            </div>
            <div class="form-field form-field-half">
              <label for="ecoTaxAmount">{{ 'addStock.ecoTax' | translate }} <span class="required-mark">*</span></label>
              <input type="number" id="ecoTaxAmount" [formControl]="newProduct.controls.ecotax" class="form-control"
                placeholder="{{ 'addStock.ecoTaxPlaceholder' | translate }}" step="0.01" min="0"
                [class.error]="newProduct.controls.ecotax.invalid && newProduct.controls.ecotax.touched">
              <div *ngIf="newProduct.controls.ecotax.invalid && newProduct.controls.ecotax.touched"
                class="error-message">
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.ecotax) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>
              </div>
            </div>

          </div>
          <div class="form-row">
            <div class="form-field form-field-full">
              <label for="description">{{ 'addStock.description' | translate }}</label>
              <textarea id="description" [formControl]="newProduct.controls.description" class="form-control" rows="3"
                placeholder="{{ 'addStock.descriptionPlaceholder' | translate }}"
                [class.error]="newProduct.controls.description.invalid && newProduct.controls.description.touched"
                [class.disabled]="newProduct.controls.description.disabled"></textarea>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field form-field-half">
              <label for="brand">{{ 'addStock.brand' | translate }} <span class="required-mark">*</span></label>
              <input type="text" id="brand" [formControl]="newProduct.controls.brand" class="form-control"
                placeholder="{{ 'addStock.brandPlaceholder' | translate }}"
                [class.error]="newProduct.controls.brand.invalid && newProduct.controls.brand.touched"
                [class.disabled]="newProduct.controls.brand.disabled">
              <div *ngIf="newProduct.controls.brand.invalid && newProduct.controls.brand.touched" class="error-message">
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.brand) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>

              </div>
            </div>
            <div class="form-field form-field-half">
              <label for="model">{{ 'addStock.model' | translate }} <span class="required-mark">*</span></label>
              <input type="text" id="model" [formControl]="newProduct.controls.model" class="form-control"
                placeholder="{{ 'addStock.modelPlaceholder' | translate }}"
                [class.error]="newProduct.controls.model.invalid && newProduct.controls.model.touched"
                [class.disabled]="newProduct.controls.model.disabled">
              <div *ngIf="newProduct.controls.model.invalid && newProduct.controls.model.touched" class="error-message">
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.model) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>

              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field form-field-half">
              <label for="width">{{ 'addStock.width' | translate }} <span class="required-mark">*</span></label>
              <input type="text" id="width" [formControl]="newProduct.controls.width" class="form-control" step="1"
                [class.error]="newProduct.controls.width.invalid && newProduct.controls.width.touched"
                [class.disabled]="newProduct.controls.width.disabled">
              <div *ngIf="newProduct.controls.width.invalid && newProduct.controls.width.touched" class="error-message">
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.width) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>
              </div>
            </div>

            <div class="form-field form-field-half">
              <label for="height">{{ 'addStock.height' | translate }} <span class="required-mark">*</span></label>
              <input type="text" id="height" [formControl]="newProduct.controls.height" class="form-control" step="1"
                [class.error]="newProduct.controls.height.invalid && newProduct.controls.height.touched"
                [class.disabled]="newProduct.controls.height.disabled">
              <div *ngIf="newProduct.controls.height.invalid && newProduct.controls.height.touched"
                class="error-message">
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.height) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>

              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field form-field-half">
              <label for="radius">{{ 'addStock.radius' | translate }} <span class="required-mark">*</span></label>
              <input type="text" id="radius" [formControl]="newProduct.controls.radius" class="form-control" step="1"
                [class.error]="newProduct.controls.radius.invalid && newProduct.controls.radius.touched"
                [class.disabled]="newProduct.controls.radius.disabled">
              <div *ngIf="newProduct.controls.radius.invalid && newProduct.controls.radius.touched"
                class="error-message">
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.radius) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>
              </div>
            </div>
            <div class="form-field form-field-half">
              <label for="loadIndex">{{ 'addStock.loadIndex' | translate }} <span class="required-mark">*</span></label>
              <input type="text" id="loadIndex" [formControl]="newProduct.controls.loadIndex" class="form-control"
                placeholder="{{ 'addStock.loadIndexPlaceholder' | translate }}"
                [class.error]="newProduct.controls.loadIndex.invalid && newProduct.controls.loadIndex.touched"
                [class.disabled]="newProduct.controls.loadIndex.disabled">
              <div *ngIf="newProduct.controls.loadIndex.invalid && newProduct.controls.loadIndex.touched"
                class="error-message">
                <!-- {{'addStock.validation_errors.load_index_required' | translate }} -->
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.loadIndex) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field form-field-half">
              <label for="speedIndex">{{ 'addStock.speedIndex' | translate }} <span
                  class="required-mark">*</span></label>
              <input type="text" id="speedIndex" [formControl]="newProduct.controls.speedIndex" class="form-control"
                placeholder="{{ 'addStock.speedIndexPlaceholder' | translate }}"
                [class.error]="newProduct.controls.speedIndex.invalid && newProduct.controls.speedIndex.touched"
                [class.disabled]="newProduct.controls.speedIndex.disabled">
              <div *ngIf="newProduct.controls.speedIndex.invalid && newProduct.controls.speedIndex.touched"
                class="error-message">
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.speedIndex) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field form-field-full">
              <label for="season">{{ 'addStock.season' | translate }} <span class="required-mark">*</span></label>
              <select id="season" [formControl]="newProduct.controls.tireSeason" class="form-control"
                [class.error]="newProduct.controls.tireSeason.invalid && newProduct.controls.tireSeason.touched"
                [class.disabled]="newProduct.controls.tireSeason.disabled">
                <option [value]="null" disabled selected hidden>{{ 'addStock.selectSeason' | translate }}</option>
                <option *ngFor="let option of seasonOptions" [value]="option.value">
                  {{ option.label | translate }}
                </option>
              </select>
              <div *ngIf="newProduct.controls.tireSeason.invalid && newProduct.controls.tireSeason.touched"
                class="error-message">
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.tireSeason) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field form-field-half">
              <label for="rollingResistance">{{ 'addStock.rollingResistance' | translate }}</label>
              <select id="rollingResistance" [formControl]="newProduct.controls.rollingResistance" class="form-control"
                [class.error]="newProduct.controls.rollingResistance.invalid && newProduct.controls.rollingResistance.touched"
                [class.disabled]="newProduct.controls.rollingResistance.disabled">
                <option [value]="null" disabled selected hidden>{{ 'addStock.selectOption' | translate }}</option>
                <option *ngFor="let option of rollingResistanceOptions" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
              <div
                *ngIf="newProduct.controls.rollingResistance.invalid && newProduct.controls.rollingResistance.touched"
                class="error-message">
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.rollingResistance) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>
              </div>
            </div>

            <div class="form-field form-field-half">
              <label for="wetGrip">{{ 'addStock.wetGrip' | translate }}</label>
              <select id="wetGrip" [formControl]="newProduct.controls.wetGrip" class="form-control"
                [class.error]="newProduct.controls.wetGrip.invalid && newProduct.controls.wetGrip.touched"
                [class.disabled]="newProduct.controls.wetGrip.disabled">
                <option [value]="null" disabled selected hidden>{{ 'addStock.selectOption' | translate }}</option>
                <option *ngFor="let option of wetGripOptions" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
              <div *ngIf="newProduct.controls.wetGrip.invalid && newProduct.controls.wetGrip.touched"
                class="error-message">
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.wetGrip) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>
              </div>
            </div>
          </div>

          <div class="form-row">


            <div class="form-field form-field-half">
              <label for="noiseLevel">{{ 'addStock.noiseLevel' | translate }} <span
                  class="required-mark">*</span></label>
              <input type="number" id="noiseLevel" [formControl]="newProduct.controls.noiseLevel" class="form-control"
                placeholder="{{ 'addStock.noiseLevelPlaceholder' | translate }}" step="1" min="0"
                [class.error]="newProduct.controls.noiseLevel.invalid && newProduct.controls.noiseLevel.touched"
                [class.disabled]="newProduct.controls.noiseLevel.disabled">
              <div *ngIf="newProduct.controls.noiseLevel.invalid && newProduct.controls.noiseLevel.touched"
                class="error-message">
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.noiseLevel) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>
              </div>
            </div>

            <div class="form-field form-field-half">
              <label for="threePMSF">{{ 'addStock.threePMSF' | translate }}</label>
              <select id="threePMSF" [formControl]="newProduct.controls.threePMSF" class="form-control"
                [class.error]="newProduct.controls.threePMSF.invalid && newProduct.controls.threePMSF.touched"
                [class.disabled]="newProduct.controls.threePMSF.disabled">
                <option [value]="null" disabled selected hidden>{{ 'addStock.selectOption' | translate }}</option>
                <option *ngFor="let option of yesNoOptions" [value]="option.value">
                  {{ option.label | translate }}
                </option>
              </select>
              <div *ngIf="newProduct.controls.threePMSF.invalid && newProduct.controls.threePMSF.touched"
                class="error-message">
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.threePMSF) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>

              </div>
            </div>
          </div>

          <!-- <div class="section-header">
            <h3>{{ 'addStock.specialFeatures' | translate }}</h3>
          </div> -->
          <!-- <div class="form-row">
            <div class="form-field form-field-half">
              <label for="mudSnow">{{ 'addStock.mudSnow' | translate }}</label>
              <select id="mudSnow" [formControl]="newProduct.controls.mudSnow" class="form-control"
                [class.error]="newProduct.controls.mudSnow.invalid && newProduct.controls.mudSnow.touched">
                <option [value]="null" disabled selected hidden>{{ 'addStock.selectOption' | translate }}</option>
                <option *ngFor="let option of yesNoOptions" [value]="option.value">
                  {{ option.label | translate }}
                </option>
              </select>
              <div *ngIf="newProduct.controls.mudSnow.invalid && newProduct.controls.mudSnow.touched"
                class="error-message">
                {{'addStock.validation_errors.mud_snow_required' | translate }}
              </div>
            </div> -->
          <!-- <div class="form-field form-field-half">
                            <label for="noiseCategory">{{ 'addStock.noiseCategory' | translate }}</label>
                            <select id="noiseCategory" [formControl]="newProduct.controls.noiseCategory" class="form-control"
                              [class.error]="newProduct.controls.noiseCategory.invalid && newProduct.controls.noiseCategory.touched">
                              <option [value]="null" disabled selected hidden>{{ 'addStock.selectNoiseCategory' | translate }}
                              </option>
                              <option *ngFor="let option of noiseCategoryOptions" [value]="option.value">
                                {{ option.label }}
                              </option>
                            </select>
                            <div *ngIf="newProduct.controls.noiseCategory.invalid && newProduct.controls.noiseCategory.touched"
                              class="error-message">
                              {{'addStock.validation_errors.noise_category_required' | translate }}
                            </div>
                          </div> 


          </div> -->

          <div class="form-row">
            <div class="form-field form-field-half">
              <label for="xlExtraload">{{ 'addStock.xlExtraload' | translate }} <span
                  class="required-mark">*</span></label>
              <select id="xlExtraload" [formControl]="newProduct.controls.extraload" class="form-control"
                [class.error]="newProduct.controls.extraload.invalid && newProduct.controls.extraload.touched"
                [class.disabled]="newProduct.controls.extraload.disabled">
                <option [value]="null" disabled selected hidden>{{ 'addStock.selectOption' | translate }}</option>
                <option *ngFor="let option of yesNoOptions" [value]="option.value">
                  {{ option.label | translate }}
                </option>
              </select>
              <div *ngIf="newProduct.controls.extraload.invalid && newProduct.controls.extraload.touched"
                class="error-message">
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.extraload) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>
              </div>
            </div>
            <div class="form-field form-field-half">
              <label for="runflat">{{ 'addStock.runflat' | translate }} <span class="required-mark">*</span></label>
              <select id="runflat" [formControl]="newProduct.controls.runflat" class="form-control"
                [class.error]="newProduct.controls.runflat.invalid && newProduct.controls.runflat.touched"
                [class.disabled]="newProduct.controls.runflat.disabled">
                <option [value]="null" disabled selected hidden>{{ 'addStock.selectOption' | translate }}</option>
                <option *ngFor="let option of yesNoOptions" [value]="option.value">
                  {{ option.label | translate }}
                </option>
              </select>
              <div *ngIf="newProduct.controls.runflat.invalid && newProduct.controls.runflat.touched"
                class="error-message">
                <ng-container *ngIf="newProduct.getFieldErrorMessage(newProduct.controls.runflat) as error">
                  {{ error.key | translate:error.params }}
                </ng-container>
              </div>
            </div>
          </div>

          <!-- <div class="section-header">
            <h3>{{ 'addStock.additionalInfo' | translate }}</h3>
          </div> -->
          <!-- <div class="form-row">
           <div class="form-field form-field-half">
              <label for="eprelUrl">{{ 'addStock.eprelUrl' | translate }}</label>
              <input type="url" id="eprelUrl" [formControl]="newProduct.controls.eprelUrl" class="form-control"
                placeholder="{{ 'addStock.eprelUrlPlaceholder' | translate }}"
                [class.error]="newProduct.controls.eprelUrl.invalid && newProduct.controls.eprelUrl.touched">
              <div *ngIf="newProduct.controls.eprelUrl.invalid && newProduct.controls.eprelUrl.touched"
                class="error-message">
                {{'addStock.validation_errors.eprel_url_required' | translate }}

              </div>
            </div> -->
          <!-- <div class="form-field form-field-half">
              <label for="eprelUrl2">{{ 'addStock.eprelUrl2' | translate }}</label>
              <input type="url" id="eprelUrl2" [formControl]="newProduct.controls.eprelUrl2" class="form-control"
                placeholder="{{ 'addStock.eprelUrl2Placeholder' | translate }}"
                [class.error]="newProduct.controls.eprelUrl2.invalid && newProduct.controls.eprelUrl2.touched">
              <div *ngIf="newProduct.controls.eprelUrl2.invalid && newProduct.controls.eprelUrl2.touched"
                class="error-message">
                {{'addStock.validation_errors.eprel_url_required' | translate }}
              </div>
            </div>
          </div>-->

          <!-- <div class="form-row">
            <div class="form-field form-field-half">
              <label for="deliveryTime">{{ 'addStock.deliveryTime' | translate }}</label>
              <input type="number" id="deliveryTime" [formControl]="newProduct.controls.deliveryTime"
                class="form-control" placeholder="{{ 'addStock.deliveryTimePlaceholder' | translate }}" min="0"
                [class.error]="newProduct.controls.deliveryTime.invalid && newProduct.controls.deliveryTime.touched">
              <div *ngIf="newProduct.controls.deliveryTime.invalid && newProduct.controls.deliveryTime.touched"
                class="error-message">
                {{'addStock.validation_errors.delivery_time_required' | translate }}
              </div>
            </div>
            <div class="form-field form-field-half">
              <label for="deliveryDate">{{ 'addStock.deliveryDate' | translate }}</label>
              <app-date-input [formControl]="newProduct.controls.deliveryDate" [showLabel]="false"
                [placeholder]="'common.selectDate'" [clearable]="true">
              </app-date-input>
            </div>
          </div> -->
        </div>





      </form>
    </div>

    <div class="form-actions">
      <button type="button" class="btn-secondary" (click)="onCancel()" [disabled]="isSubmitting">
        {{ 'common.cancel' | translate }}
      </button>
      <button type="button" class="btn-primary" (click)="onSubmit()">
        <span *ngIf="isSubmitting" class="loading-spinner"></span>
        {{ isSubmitting ? ('common.saving' | translate) : ('common.save' | translate) }}
      </button>
    </div>
  </div>
</div>